import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export type Maps = typeof google.maps;

@Injectable({
  providedIn: 'root',
})
export class GoogleApiService {
  private maps: Maps | null = null;
  private sessionToken: google.maps.places.AutocompleteSessionToken | any = null;

  apiKey = environment.googleMapsApiKey;

  constructor() {}

  /** Load Maps JS */
  public loadGoogleMapsAPI(): Promise<typeof google.maps> {
    if (this.maps) return Promise.resolve(this.maps);

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places,marker`;
      script.async = true;

      script.onload = () => {
        this.maps = google.maps;
        resolve(google.maps);
      };

      script.onerror = () => reject('Failed to load Google Maps API');

      document.body.appendChild(script);
    });
  }

  /** Start new session for autocomplete */
  startAutocompleteSession() {
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    console.log(this.sessionToken,'-token')
  }

  /** Get autocomplete predictions */
  getPredictions(input: string): Promise<google.maps.places.AutocompletePrediction[]> {
    if (!this.sessionToken) this.startAutocompleteSession();

    return this.loadGoogleMapsAPI().then((maps) => {
      const service = new maps.places.AutocompleteService();

      return new Promise((resolve) => {
        service.getPlacePredictions(
          {
            input,
            sessionToken: this.sessionToken,
          },
          (predictions) => resolve(predictions || [])
        );
      });
    });
  }

  /** Get full place details */
 getPlaceDetails(placeId: string): Promise<any> {
  return this.loadGoogleMapsAPI().then((maps) => {
    const service = new maps.places.PlacesService(
      document.createElement('div')
    );

    return new Promise((resolve) => {
      service.getDetails(
        { 
          placeId,
          sessionToken: this.sessionToken,
        },
        (result) => {
          this.sessionToken = null; // Reset after completing selection
          resolve(result);
        }
      );
    });
  });
}


  /** Get address from lat/lng */
 getAddressFromLatLng(
  lat: number | string | null,
  lng: number | string | null
): Promise<string> {
  if (!lat || !lng) return Promise.resolve('');

  return this.loadGoogleMapsAPI().then((maps) => {
    const geocoder = new maps.Geocoder();
    const latLng = new maps.LatLng(Number(lat), Number(lng));

    return new Promise<string>((resolve) => {
      geocoder.geocode({ location: latLng }, (results, status) => {
        resolve(results?.[0]?.formatted_address || '');
      });
    });
  });
}

}
